import React from "react";
import { Modal, Button, Input, Badge, Avatar, Tooltip } from "antd";
import {
  setCloseDashboardFlag,
  setDuplicateDashboardFlag,
  setOpenNewDashboardFlag,
  setSaveDashboardModalFlag,
  updateDashboardGlobleFilters,
} from "../../../../redux/actions/ApiCall/apiCall";
import { useDispatch, useSelector } from "react-redux";
import {
  deepCopy,
  getGlobalFilterAndFilterCountObject,
  getPaneIndex,
  removeHiddenFromSaved,
  removePrivateConversationFilters,
} from "../../../../redux/constants";
import { memo } from "react";
import {
  onEdit,
  setSelectedPillInPane,
} from "../../../../redux/actions/dashboard/Tab1";
import { updateAuthParamsTemplateId } from "../../../../redux/actions/AuthParams";

const { TextArea } = Input;

const SaveDashboardModal = ({ isModalShow, setIsModalSaveAs }) => {
  const dispatch = useDispatch();
  const authParams = useSelector((state) => state.Authentication.authParams);
  const panes = useSelector((state) => state?.Tab1?.panes);
  const activeKey = useSelector((state) => state?.Tab1?.activeKey);
  const graphConditionConfig = useSelector(
    (state) => state?.apiCall?.graphConditions
  );
  const All_Share_attributes = useSelector(
    (state) => state.WidgetMaker.All_Share_attributes
  );
  const brandlogicalgroup = useSelector(
    (state) => state.ApiCall.brandlogicalgroup?.data?.result
  );
  let index = getPaneIndex(panes, activeKey);

  const globalFinalFilter = getGlobalFilterAndFilterCountObject(
    "view_dashboard",
    deepCopy(panes[index]),
    graphConditionConfig
  );

  const brands = useSelector(
    (state) => state.ApiCall.brands?.data?.result?.brands
  );
  const templateDetails = useSelector((state) => state.Section.templateDetails);
  const global_dashboard_duration = useSelector(
    (state) => state.AuthParams.global_dashboard_duration
  );
  const global_dashboard_brands = useSelector(
    (state) => state.AuthParams.global_dashboard_brands
  );
  const global_dashboard_single_brands = useSelector(
    (state) => state.AuthParams.global_dashboard_single_brands
  );
  const competitorBrands = useSelector(
    (state) => state.WidgetAPI.competitorBrands?.data?.result
  );
  const temporary_words = useSelector(
    (state) => state.attributes.temporary_words
  );
  const duplicateDashboardLoader = useSelector(
    (state) => state?.ApiCall?.duplicateDashboardLoader
  );
  const closeDashboardFlag = useSelector(
    (state) => state?.ApiCall?.closeDashboardFlag
  );
  const openNewDashboardFlag = useSelector(
    (state) => state?.ApiCall?.openNewDashboardFlag
  );

  const handleCancel = () => {
    dispatch(setSaveDashboardModalFlag(false));
    dispatch(setCloseDashboardFlag(false));
    dispatch(setOpenNewDashboardFlag(false));
  };

  const handleDontSave = () => {
    if (openNewDashboardFlag) {
      setIsModalSaveAs(false);
      dispatch(setSaveDashboardModalFlag(false));

      let paneObj = {
        index: index,
        brands: brandlogicalgroup?.length > 0 ? brandlogicalgroup : brands,
        singleBrands: brands,
        panes: panes,
        activeKey: activeKey,
        firstSection: true,
        templateDetails: templateDetails,
        global_dashboard_duration: global_dashboard_duration,
        global_dashboard_brands: global_dashboard_brands,
        global_dashboard_single_brands: global_dashboard_single_brands,
        competitorBrands: competitorBrands,
        type: window.location.pathname === "/schedule" ? "report" : "dashboard",
        graphConditionConfig: graphConditionConfig,
        temporary_words: temporary_words,
        is_modified_date:
          panes?.[index]?.template_id === "000-000-002" ||
          panes?.[index]?.template_id === "000-000-004"
            ? panes?.[index]?.is_modified_date
              ? panes?.[index]?.is_modified_date
              : false
            : null,
      };
      dispatch(
        onEdit(
          panes?.[index]?.key,
          "add",
          panes,
          activeKey,
          authParams,
          paneObj
        )
      );

      if (authParams?.template_id && authParams?.redirectToDIY) {
        dispatch(
          updateAuthParamsTemplateId(authParams, {
            template_id: null,
            // redirectToDIY: null,
          })
        );
      }
    } else if (closeDashboardFlag) {
      setIsModalSaveAs(false);
      dispatch(setSaveDashboardModalFlag(false));

      let paneObj = {
        index: index,
        brands: brandlogicalgroup?.length > 0 ? brandlogicalgroup : brands,
        singleBrands: brands,
        panes: panes,
        activeKey: activeKey,
        firstSection: true,
        templateDetails: templateDetails,
        global_dashboard_duration: global_dashboard_duration,
        global_dashboard_brands: global_dashboard_brands,
        global_dashboard_single_brands: global_dashboard_single_brands,
        competitorBrands: competitorBrands,
        type: window.location.pathname === "/schedule" ? "report" : "dashboard",
        graphConditionConfig: graphConditionConfig,
        temporary_words: temporary_words,
        is_modified_date:
          panes?.[index]?.template_id === "000-000-002" ||
          panes?.[index]?.template_id === "000-000-004"
            ? panes?.[index]?.is_modified_date
              ? panes?.[index]?.is_modified_date
              : false
            : null,
      };
      // console.log("Inside close panes", panes?.[index]);
      dispatch(
        onEdit(
          panes?.[index]?.key,
          "remove",
          panes,
          activeKey,
          authParams,
          paneObj
        )
      );

      if (authParams?.template_id && authParams?.redirectToDIY) {
        dispatch(
          updateAuthParamsTemplateId(authParams, {
            template_id: null,
            // redirectToDIY: null,
          })
        );
      }
    } else {
      dispatch(setSaveDashboardModalFlag(false));
    }
  };

  const handleSaveAsDashboard = (e) => {
    let notMatchedFilters = removePrivateConversationFilters(
      panes?.[index]?.comp_hidden_filter,
      panes?.[index]?.filters,
      panes?.[index]?.saved_filters
    );

    const selectedPill = panes[index]?.selected_pills
      ? panes[index]?.selected_pills
      : [];
    if (selectedPill?.[0]?.saved_filters?.length) {
      notMatchedFilters = removeHiddenFromSaved(
        deepCopy(notMatchedFilters),
        deepCopy(selectedPill?.[0]?.saved_filters)
      );
      panes[index].filters = removeHiddenFromSaved(
        deepCopy(panes[index].filters),
        deepCopy(selectedPill?.[0]?.saved_filters)
      );
    }

    let obj = {
      template_id: panes?.[index]?.template_id,
      filters:
        panes?.[index]?.template_type === "competition"
          ? notMatchedFilters?.length
            ? notMatchedFilters
            : []
          : panes?.[index]?.filters?.length
          ? panes?.[index]?.filters
          : [],
      saveAsFlag: true,
      authParams: authParams,
      index: index,
      panes: panes,
    };

    // console.log("Call New API", obj);
    dispatch(updateDashboardGlobleFilters(obj));
    if (selectedPill?.[0]?.saved_filters?.length) {
      dispatch(setSelectedPillInPane(selectedPill?.[0], index, panes));
    }
  };

  const handleCreateNewDashboard = () => {
    setIsModalSaveAs(true);
    dispatch(setDuplicateDashboardFlag(true));
    dispatch(setSaveDashboardModalFlag(false));
  };

  return (
    <Modal
      // title={
      //   <div className="d-flex justify-content-between">Save Dashboard</div>
      // }
      visible={isModalShow}
      onOk={handleSaveAsDashboard}
      onCancel={handleCancel}
      footer={[
        (closeDashboardFlag || openNewDashboardFlag) && (
          <Button
            style={{ float: "left" }}
            type="button"
            className="btn_Clear"
            onClick={handleDontSave}
          >
            Don't Save & Exit
          </Button>
        ),
        !panes?.[index]?.predefined && (
          <Button
            type="button"
            className="ant-btn-primary_blue"
            onClick={handleSaveAsDashboard}
            loading={duplicateDashboardLoader ? true : false}
          >
            Save Dashboard
          </Button>
        ),
        <Button
          type="primary"
          className="ant-btn-primary_blue"
          onClick={handleCreateNewDashboard}
        >
          Save As
        </Button>,
      ]}
      width={550}
      closable={true}
      maskClosable={false}
      className={
        authParams?.theme_type === "1" ? "formModal darkTheme" : "lightTheme"
      }
    >
      <div className="text_heading-Slab text-transform__none">
        How would you like to save this dashboard ?
        <p className="share_link_sub_text mt-15">
          To save any changes you have made to the current dashboard, just click
          "Save Dashboard". If you would like to create a duplicate of the
          current setup, select "Save As".
        </p>
      </div>
    </Modal>
  );
};

export default memo(SaveDashboardModal);
